import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { trackPurchase } from "../services/facebookAPI";

interface ThankYouPageProps {
  orderDetails: any;
}

const ThankYouPage: React.FC<ThankYouPageProps> = ({ orderDetails }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Facebook Conversion API - Ensure purchase is tracked
    if (orderDetails && !orderDetails.facebook_tracked) {
      console.log("📊 Facebook: Ensuring purchase tracking...");
      
      const formDataForFacebook = {
        firstName: orderDetails.name?.split(' ')[0] || orderDetails.name || '',
        lastName: orderDetails.name?.split(' ').slice(1).join(' ') || '',
        phone: orderDetails.phone || '',
        email: orderDetails.email || `${orderDetails.phone || ''}@customer.tpa.com`,
        state: orderDetails.state || '',
      };
      
      const orderId = orderDetails.orderId || `SUPERGRO-${Date.now()}`;
      
      trackPurchase(orderId, formDataForFacebook)
        .then((tracked) => {
          console.log("📊 Facebook Purchase Event:", tracked ? "✅ Tracked" : "❌ Failed");
        })
        .catch((error) => {
          console.error("❌ Facebook tracking error:", error);
        });
    } else if (orderDetails?.facebook_tracked) {
      console.log("✅ Facebook purchase already tracked");
    }
  }, [orderDetails]);

  // Get order ID for display
  const getOrderId = () => {
    if (orderDetails?.orderId) return orderDetails.orderId;
    if (orderDetails?.metadata?.order_id) return orderDetails.metadata.order_id;
    return `SUPERGRO-${Date.now()}`;
  };

  // Format amount with commas
  const formatAmount = (amount?: number) => {
    if (amount === undefined || amount === null) return '';
    return amount.toLocaleString();
  };

  // Get the actual amount to display
  const displayAmount = () => {
    // Prefer the amount from orderDetails
    if (orderDetails?.amount) {
      return `₦${formatAmount(orderDetails.amount)}`;
    }
    // Fallback to old hardcoded logic (should not happen if orderDetails is complete)
    const fallback = orderDetails?.paymentMethod === "paystack" ? "65,000" : "70,000";
    return `₦${fallback}`;
  };

  return (
    <div className="thank-you-page">
      <div className="container">
        <div className="thank-you-card card">
          <div className="success-icon">✅</div>

          <h1>Order Confirmed!</h1>
          <p className="subtitle">
            Thank you for choosing The Peters Agriculture
          </p>

          <div className="order-details">
            <div className="detail-item">
              <span className="detail-label">Order ID:</span>
              <span className="detail-value">{getOrderId()}</span>
            </div>

            <div className="detail-item">
              <span className="detail-label">Product:</span>
              <span className="detail-value">
                Super Gro Organic Fertilizer (5L)
              </span>
            </div>

            {/* NEW: Display quantity */}
            <div className="detail-item">
              <span className="detail-label">Quantity:</span>
              <span className="detail-value">
                {orderDetails?.quantity || 1}
              </span>
            </div>

            <div className="detail-item">
              <span className="detail-label">Total Amount:</span>
              <span className="detail-value">
                {displayAmount()}
              </span>
            </div>

            <div className="detail-item">
              <span className="detail-label">Payment Method:</span>
              <span className="detail-value">
                {orderDetails?.paymentMethod === "paystack"
                  ? "PayStack (Online)"
                  : "Pay on Delivery"}
              </span>
            </div>

            <div className="detail-item">
              <span className="detail-label">Delivery Time:</span>
              <span className="detail-value">48-72 hours</span>
            </div>
          </div>

          <div className="delivery-instructions">
            <h3>What Happens Next?</h3>
            <ol>
              <li>Our delivery team will contact you within 24 hours</li>
              <li>Please keep your phone available for delivery updates</li>
              <li>Have your payment ready if you chose "Pay on Delivery"</li>
              <li>Delivery will be attempted within 48-72 hours</li>
            </ol>
          </div>

          <div className="contact-support">
            <h3>Need Help?</h3>
            <p>
              Call/WhatsApp: <strong>0703-98806-55</strong>
            </p>
            <p>
              Email: <strong>support@thepetersagriculture.com</strong>
            </p>
          </div>

          <div className="action-buttons">
            <button className="btn btn-primary" onClick={() => navigate("/")}>
              Back to Home
            </button>

            <button
              className="btn btn-secondary"
              onClick={() => window.print()}
            >
              Print Receipt
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
